export default function () {
  return {
    cachefilters: [],
    cachefiltersCurrentPage: 1,
    cachefiltersLastPage: 1,
    cachefiltersPerPage: 0,
    cachefiltersTotal: 0,
    cachefiltersLoading: false,
    indexPage: null
  }
}
